module.exports = __webpack_public_path__ + "static/media/activedrive.0f60a028.jpg";